/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(function(){
    // FAQ
    $('.p-faq__list dt').click(function(){
        $(this).next('dd').slideToggle();
    });
});

    /**
     * ----------------------------------------------------------------------------
     * sections/main-collection-itoguchi.liquid
     *
     * Calculate vertical line position and width
     * ----------------------------------------------------------------------------
     */
const itoguchiText = document.querySelector('.js-p-collection-itoguchi__section-inner');
const itoguchiTextInner = document.querySelector('.js-p-collection-itoguchi__section-text-inner');
const headingIntro = document.querySelector('.js-SectionHeader__Heading');
const verticalLine = document.querySelector('.p-collection-itoguchi__section-vertical-line');

function setLinePositionY() {
    // 1. itoguchiTextの高さを取得
    let itoguchiText_h = itoguchiText.clientHeight;
    // 2. itoguchiTextInnerの高さを取得
    let itoguchiTextInner_h = itoguchiTextInner.clientHeight;
    // 3. 1から2を引く
    let itoguchiText_gap = itoguchiText_h - itoguchiTextInner_h;
    // 4. 3(余った上下の余白)を2で割る
    let itoguchiText_gap_half = itoguchiText_gap * 0.5;
    // 5. 4の数値+見出しの高さを2で割った数値をposition topに設定する
    let headingIntro_h = headingIntro.clientHeight;
    const headingIntro_h_half = headingIntro_h * 0.5;
    const linePositionY = itoguchiText_gap_half + headingIntro_h_half + 'px';
    verticalLine.style.top = linePositionY;
}
function setLineWidth() {
    // 1. itoguchiTextの幅を取得
    let itoguchiText_w = itoguchiText.clientWidth;
    // 2. itoguchiTextInnerの幅を取得
    let itoguchiTextInner_w = itoguchiTextInner.clientWidth;
    // 3. 1から2を引く
    let itoguchiText_gap = itoguchiText_w - itoguchiTextInner_w;
    // 4. 3(余った左右の余白)を2で割る
    let itoguchiText_gap_half = itoguchiText_gap * 0.5;
    // 5. CSS変数'--vertical-spacing'の値を取得
    const itoguchiTextStyle = getComputedStyle(itoguchiText);
    const itoguchiTextStyleValue = String(itoguchiTextStyle.getPropertyValue('--vertical-spacing')).trim();
    const itoguchiTextStyleValueNum = itoguchiTextStyleValue.replace('px', '');
    const itoguchiTextStyleValueNumHalf = itoguchiTextStyleValueNum * 0.5;
    // 6. CSS変数'--vertical-spacing'を2で割った数値を1から引いた数をwidthに設定する
    const lineWidth = itoguchiText_gap_half - itoguchiTextStyleValueNumHalf - 6 + 'px';
    verticalLine.style.width = lineWidth;
}
window.addEventListener('DOMContentLoaded',() => {
    setLinePositionY();
    setLineWidth();
});
window.addEventListener('resize',() => {
    setLinePositionY();
    setLineWidth();
});